module.exports = __webpack_public_path__ + "static/media/serv2.071f5027.png";